// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo-image[data-v-fce77350] {\n  height: 200px;\n  width: 200px;\n  max-width: 200px;\n  top: -60px;\n  left: -60px;\n  opacity: 0.05;\n  position: absolute;\n  margin-right: 0.5rem;\n  border-radius: 9999px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
